angular.injector(['ng', 'translate']).invoke([  'translationLoader',  function (translationLoader) {    translationLoader.addTranslationPartial({
  "PAY_MODAL": {
    "CARD_INVALID": "Card Number invalid",
    "HOLDER_NAME_INVALID": "Card Holder Name invalid",
    "EXPIRY_MONTH_INVALID": "Expiry Month invalid",
    "EXPIRY_YEAR_INVALID": "Expiry Year invalid",
    "CVC_INVALID": "Security Code invalid",
    "CVC_TOOLTIP": "The security code is the last 3 numbers on the back of your card (4 numbers on the front if Amex)",
    "FUTURE_USE": "Saving your card details means that you won’t have to re-enter this information the next time you pay for your booking or subscription.",
  }
}
);  }]);


//////////////////
// WEBPACK FOOTER
// ./webpack_loaders/nls.js!./app/src/components/pay_modal/pay_modal.json
// module id = 428
// module chunks = 24